import React, { useEffect, useState } from "react";
import { getMarketPrice } from "../../../helpers";

const ProtocolStats = () => {
  const data = [
    {
      title: "Defi PRICE",
      price: "$12.502",
    },
    {
      title: "Market Cap",
      price: "$ 32,212,221",
    },
    {
      title: "Protocol Liquidity",
      price: "99.37%",
    },
    {
      title: "APY",
      price: "48.2%",
    },
  ];

  const [contractValues, setContractValues] = useState([0, 0, 0, 0]);

  useEffect(() => {
    fetchContractValues();
  }, []);

  const fetchContractValues = async () => {
    let priceVal = await getMarketPrice();
    let tmpValues = [...contractValues];
    tmpValues[0] = priceVal.marketPrice;
    tmpValues[1] = priceVal.marketCap;
    tmpValues[2] = priceVal.liquidity;
    tmpValues[3] = priceVal.apy * 100;
    setContractValues(tmpValues);
  }

  const convertUIText = (idx) => {
    let val = contractValues[idx];
    if (idx != 3) {
      return "$" + Number(val).toLocaleString();
    } else {
      return Number(val).toLocaleString() + "%";
    }
  }

  return (
    <section className="protocol-stats py-10 text-dark ">
      <div className="container">
        <h2 className="text-center text-[36px] font-semibold">
          Protocol stats
        </h2>

        <div className="grid md:grid-cols-4 mt-10 gap-10">
          {data.map((val, i) => (
            <div key={i} className="">
              <div className="max-w-max mx-auto md:text-left text-center">
                <h4 className="text-[#604A00] uppercase text-sm tracking-wider">
                  {val.title}
                </h4>
                <p className="text-[32px] font-semibold">{convertUIText(i)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProtocolStats;
